import React, { useCallback, useState } from "react";
import { Card, Icon, Statistic } from "antd";
import StatisticPeriod from "./StatisticsPeriod";
import { getPlaceStatistics } from "../../service/places";

export default function PlaceStatistics() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const onChange = useCallback(async (range) => {
    // setLoading(true);
    const data = await getPlaceStatistics({ range, count: true });
    setData({ total: data.total, range: data.range.toString() })
    // setLoading(false);
  }, []);
  return (
    <Card>
      <Statistic
        title={<span>Places <StatisticPeriod onChange={onChange}/></span>}
        value={data.total}
        prefix={<Icon type="environment" />}
        suffix={<span className="color-grey">{data.range}</span>}
      />
    </Card>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/PlaceStatistics.js